import React, { useEffect } from 'react'
import { Navbar } from './Navbar'
import { RightMenu } from './RightMenu'
import { useState } from 'react'
import { Navigate, Outlet } from 'react-router'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { useDispatch } from 'react-redux'
import { logoutSuccess } from '../state/authRedux'
import { FaUserCircle } from "react-icons/fa";
import { HiOutlineLogout } from "react-icons/hi";

export const Layout = ({children}) => {

    const [inactiveTimer, setInactiveTimer] = useState(null);
    const navigate = useNavigate();
    
    const [open,setOpen] = useState(false)
    const highlight = useSelector((state)=>state.highlight.index)
    const dispatch = useDispatch()

    const logout = () => {
        // Clear user session (e.g., remove tokens, clear state)
        dispatch(logoutSuccess())
        navigate('/login'); // Redirect to login page
    };

    
    const resetTimer = () => {
        if (inactiveTimer) {
          clearTimeout(inactiveTimer); // Clear the previous timer
        }
        const newTimer = setTimeout(logout, 480000); // 8 milliseconds
        setInactiveTimer(newTimer); // Set the new timer
    };

    // Track user activity (mouse, keyboard, etc.)
    const trackActivity = () => {
    resetTimer(); // Reset timer whenever there's user activity
    }

    /*
    useEffect(() => {
        // Set the initial timer
        resetTimer();
    
        // Add event listeners for user activity
        window.addEventListener('mousemove', trackActivity);
        window.addEventListener('keypress', trackActivity);
    
        // Clean up event listeners and timers
        return () => {
          clearTimeout(inactiveTimer);
          window.removeEventListener('mousemove', trackActivity);
          window.removeEventListener('keypress', trackActivity);
        };
      }, []);*/
  
    return (
        

            /*user && user.data.isAuthenticated ?*/
                <div className='  h-[100%] w-[100%] flex relative overflow-hidden bg-[#030527]'>
                    <Navbar open={open} setOpen={setOpen} highlight={highlight}/>
                    <div className={`bg-[#030527]  h-screen bg-recision overflow-y-auto ${open?"w-[20%]":"w-[90%]"} ${open?"md:w-[85%]":"md:w-[95%]"} md:z-0 text-sm font-semibold duration-300 ease-in-out`} >
                        <Outlet/>
                    </div>
                </div>/*:<Navigate to={`login`}/>*/
    )
}

{/*
    user && user.isAuthenticated ?
    <div className='h-[100%] w-[100%] md:flex relative'>
         <Navbar open={open} setOpen={setOpen} highlight={highlight}/>
         <div className={`xs:w-[100%] xs:top-0 xs:z-0 xs:h-full xs:relative md:relative md:z-0 text-sm font-semibold ${open?"md:w-[85%]":"md:w-[95%]"}`} >
            <Outlet/>
         </div>
    </div>:<Navigate to={`login`}/>*/}
